export class Tenant {
	constructor({ tenantId, name, shortCode, settings } = {}) {
		this.tenantId = tenantId;
		this.name = name;
		this.shortCode = shortCode;
		this.settings = new TenantSettings(settings);
	}
}

export class TenantSettings {
	constructor({
		brandImages = new TenantBrandImages(),
		brandName = 'Locumbase Vets',
		brandUrl = 'https://www.locumbase.com',
		brandYoutubeUrl = '',
		brandAdvertImageLeft = '',
		brandAdvertImageRight = '',
		brandAdvert = new TenantBrandAdvert(),
		theme = new TenantTheme(),
		wallet = new Wallet(),
		links = new TenantLinks(),
		workflow = new TenantWorkflow(),
	} = {}) {
		this.brandImages = new TenantBrandImages(brandImages);
		this.brandName = brandName;
		this.brandUrl = brandUrl;
		this.brandYoutubeUrl = brandYoutubeUrl;
		this.brandAdvertImageLeft = brandAdvertImageLeft;
		this.brandAdvertImageRight = brandAdvertImageRight;
		this.brandAdvert = new TenantBrandAdvert(brandAdvert);
		this.links = new TenantLinks(links);
		this.theme = new TenantTheme(theme);
		this.wallet = new Wallet(wallet);
		this.workflow = new TenantWorkflow(workflow);
	}

	set(vuetify) {
		document.title = this.brandName;
		this.theme.set(vuetify);
		this.setFavicon();
		this.loadChat();
	}

	setFavicon() {
		if (!this.brandImages.favicon || !this.brandImages.favicon.auth) return;
		var link = document.querySelector("link[rel~='icon']");
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.head.appendChild(link);
		}
		link.href = this.brandImages.favicon.auth;
	}

	loadChat() {
		let chatFileName = null;

		if (this.workflow.support.tawk.active) {
			chatFileName = 'tawk-chat';
		} else if (this.workflow.support.brevo.active) {
			chatFileName = 'brevo-chat';
		}

		if (chatFileName) {
			this._setChatScript(chatFileName);
		}
	}

	_setChatScript(chatFileName) {
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = `js/${chatFileName}.js`;
		document.head.appendChild(script);
	}
}

export class TenantTheme {
	constructor({
		primary = '#FF5F05', //Orange
		secondary = '#4D88A1', //Cyan
		accent = '#009CEF', // Blue
		error = '#F44336', //Red
		anchor = '#FF5F05',
		background = '#FFFFFFF',
	} = {}) {
		this.primary = primary;
		this.secondary = secondary;
		this.accent = accent;
		this.error = error;
		this.anchor = anchor;
		this.background = background;
	}

	set(vuetify) {
		vuetify.framework.theme.themes.light.primary = this.primary;
		vuetify.framework.theme.themes.light.secondary = this.secondary;
		vuetify.framework.theme.themes.light.accent = this.accent;
		vuetify.framework.theme.themes.light.error = this.error;
		vuetify.framework.theme.themes.light.anchor = this.anchor;
		vuetify.framework.theme.themes.light.background = this.background;
	}
}

const iHeaderLogos = {
	app: {
		light: '',
		dark: '',
	},
	auth: {
		light: '',
		dark: '',
	},
};

const iDashboardImage = {
	company: '',
	professional: '',
};

const iFavicon = {
	app: '',
	auth: '',
};

const iTawk = {
	active: true,
};

const iBrevo = {
	active: false,
};

const iAdvert = {
	image: '',
	url: '',
};

export class TenantBrandImages {
	constructor({ headerLogos = iHeaderLogos, dashboardImage = iDashboardImage, favicon = iFavicon } = {}) {
		this.headerLogos = headerLogos;
		this.dashboardImage = dashboardImage;
		this.favicon = favicon;
	}
}

export class TenantBrandAdvert {
	constructor({ left = iAdvert, right = iAdvert } = {}) {
		this.left = left;
		this.right = right;
	}
}

export class Wallet {
	constructor({ show = false } = {}) {
		this.show = show;
	}
}

export class TenantWorkflow {
	constructor({ support = new TenantSupport() } = {}) {
		this.support = new TenantSupport(support);
	}
}

export class TenantSupport {
	constructor({ tawk = iTawk, brevo = iBrevo } = {}) {
		this.tawk = tawk;
		this.brevo = brevo;
	}
}

export class TenantLinks {
	constructor({ faq = '', terms = '', blog = '', contact = '', downloads = '', tutorials = '' } = {}) {
		this.faq = faq;
		this.terms = terms;
		this.blog = blog;
		this.contact = contact;
		this.downloads = downloads;
		this.tutorials = tutorials;
	}
}

export default Tenant;
